export const RegistryPedigreeSection = ({ formData, update, isStudOrMare }) => (
  <div className="glass-card p-6 space-y-6">
    <h2 className="text-xl text-[#EDEDED] mb-4">Registry & Pedigree</h2>

    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">Registry Organization</label>
        <input
          type="text"
          value={formData.registry_organization}
          onChange={(e) => update({ registry_organization: e.target.value })}
          className="input-minimal"
          placeholder="e.g., AKC, AQHA, CFA"
        />
      </div>
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">Registration Number</label>
        <input
          type="text"
          value={formData.registration_number}
          onChange={(e) => update({ registration_number: e.target.value })}
          className="input-minimal"
          placeholder="e.g., 1234567"
        />
      </div>
    </div>

    {isStudOrMare && (
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">Genetics / Pedigree Information</label>
        <textarea
          value={formData.pedigree_info}
          onChange={(e) => update({ pedigree_info: e.target.value })}
          className="input-minimal min-h-[100px]"
          placeholder="Describe bloodlines, genetic testing results, notable ancestors..."
        />
      </div>
    )}
  </div>
);
